// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"cecfadb9","112":"251f43bd","124":"37d3572a","982":"22262980"}[chunkId] + ".chunk.js";
};